import { css, keyframes } from "styled-components";
import { duration, easing } from "./transitions";

const enter = keyframes`
  from { opacity: 0; transform: translateY(-0.25rem) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
`;

const exit = keyframes`
  from { opacity: 1; transform: translateY(0) scale(1); }
  to { opacity: 0; transform: translateY(-0.25rem) scale(0.98); }
`;

/** How long a closing popover stays mounted so its exit animation can play (matches `duration.fast`). */
export const POPOVER_EXIT_MS = 150;

/**
 * Shared enter and exit motion for every popover, dropdown and menu panel: opacity plus a small
 * translate and scale, `duration.fast`, ease-out. Pass `closing` while the exit plays (see `usePresence`).
 * Reduced motion turns it off. Apply to the panel only once it is placed, so it never animates from a wrong spot.
 */
export const popoverMotion = (closing = false) => css`
  transform-origin: top center;
  animation: ${closing ? exit : enter} ${duration.fast} ${easing.slideIn} both;
  pointer-events: ${closing ? "none" : "auto"};

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
